import React, { useCallback } from "react";
import { Select, SelectOnChangeData, Subtitle1, useId } from "@fluentui/react-components";
import { useStyles } from "./BuildingSorterStyles";
import {
  BuildingSortOption,
  appInsightsEvents,
  sortOption,
  trackEvent,
  useAppStore,
} from "../../../common";

export const BuildingSorter = () => {
  const styles = useStyles();
  const [appInsights, context, sortedBy, sort] = useAppStore((state) => [
    state.appInsights,
    state.context,
    state.buildings.sortedBy,
    state.buildings.sort,
  ]);

  const selectId = useId();

  // Makes <option />s for each option, while disabling "Nearest".
  const renderOptions = useCallback(
    (options: string[]) =>
      options.map((option) => (
        <option className={styles.option} key={option} disabled={option === "Nearest"}>
          {option}
        </option>
      )),
    [styles],
  );

  const onSelect = useCallback(
    (data: SelectOnChangeData) => {
      sort(data.value as BuildingSortOption);
      trackEvent(appInsights, appInsightsEvents.Usage.Actions.SortBuildings, context, {
        sortedBy: data.value,
      });
    },
    [appInsights, context],
  );

  return (
    <header className={styles.container} data-testid="buildingSorter">
      <Subtitle1 className={styles.headerText}>All locations</Subtitle1>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Select
          id={selectId}
          aria-label={`Sort Buildings ${sortedBy}`}
          value={sortedBy}
          onChange={(e, data) => onSelect(data)}
        >
          {renderOptions(sortOption)}
        </Select>
      </div>
    </header>
  );
};
